export const previousLivestreamData = [
  {
    "creatorAddress": "0x8b7d4d94cb94b359b37eeb9a43872F869f74164e",
    "creatorImage": "https://pbs.twimg.com/profile_images/1469366926367465478/dRQlA5aM_400x400.jpg",
    "creatorName": "dosaDAO",
    "image": "https://i.ibb.co/Zm1GhwF/Screen-Shot-2022-11-03-at-11-01-41-AM.png",
    "itemName": "Chai Time with Ajay Mehta",
    "itemRoute": "/profile/dosa"
  },
  {
    "creatorAddress": "0x0105eece5b222acf7a1685d75899f410d1320628",
    "creatorImage": "https://pbs.twimg.com/profile_images/1542541226267889665/jNY749F1_400x400.jpg",
    "creatorName": "YahZarah",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/ivs/v1/800915468397/gJUQtfnfbv6s/2022/10/27/23/48/BT3ppZmFszQY/media/thumbnails/thumb80.jpg",
    "itemName": "Genesis Livestream",
    "itemRoute": "/profile/yahzarah"
  },
  {
    "creatorAddress": "0x0d910be7bd2a29e812b2156e21651cde64132b18",
    "creatorImage": "https://the402.mypinata.cloud/ipfs/QmVhoAuX2BCLXSNDAoxh9BFRCBZY38sMKd32ETEnF52Q4y",
    "creatorName": "Joe Rian",
    "image": "https://i.ibb.co/hm2DJ46/Screen-Shot-2022-11-03-at-11-10-34-AM.png",
    "itemName": "Livestream 001",
    "itemRoute": "/profile/joerian"
  },
  {
    "creatorAddress": "0x40d65ec8870d0fca1197593291f873fb0b3787db",
    "creatorImage": "https://i.scdn.co/image/ab6761610000e5eb1562c90aa8c10e245b44b857",
    "creatorName": "Emma Miller",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/imageedit_8_8507781346.jpg",
    "itemName": "One Voice ft. Emma Miller",
    "itemRoute": "/profile/emmamiller"
  },
  {
    "creatorAddress": "0x6d5969f4472e2a1ef14fe5326933f1cf88c015e6",
    "creatorImage": "https://pbs.twimg.com/profile_images/1554896370263379968/bu6hsLB8_400x400.jpg",
    "creatorName": "X&ND",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/ivs/v1/800915468397/9ugHG63zWLQD/2022/10/14/0/26/FiAKJ4YOWY4E/media/thumbnails/thumb66.jpg",
    "itemName": "STUDIO 002",
    "itemRoute": "/profile/x&nd"
  },
  {
    "creatorAddress": "0x7933231775dEc3f3c80039DEbd7E3afD8A81f674",
    "creatorImage": "https://pbs.twimg.com/profile_banners/3304027585/1652511739/1500x500",
    "creatorName": "UVR",
    "image": "https://i.ibb.co/bKsdjxh/Screen-Shot-2022-11-03-at-11-29-54-AM.png",
    "itemName": "GATED AND UNCUT",
    "itemRoute": "/profile/UVR"
  },
  {
    "creatorAddress": "0x6d5969f4472e2a1ef14fe5326933f1cf88c015e6",
    "creatorImage": "https://pbs.twimg.com/profile_images/1554896370263379968/bu6hsLB8_400x400.jpg",
    "creatorName": "X&ND",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/image+-+2022-10-03T201925.616.png",
    "itemName": "STUDIO 001",
    "itemRoute": "/profile/x&nd"
  },
  {
    "creatorAddress": "0xf873e05c28be2845f09c828dae42084b6b1c060e",
    "creatorImage": "https://pbs.twimg.com/profile_images/1585290685560791040/LM1GStmT_400x400.jpg",
    "creatorName": "Dom Deshawn",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmSCwuTv4qCf43FJNExHUSTjvJvadw81y5W7PHMdVwm6Tw.png",
    "itemName": "Last Night of Summer",
    "itemRoute": "/profile/domdeshawn"
  },
  {
    "creatorAddress": "0x0f1af0576ea168db8b1d4775589b762124ec3c4a",
    "creatorImage": "https://pbs.twimg.com/profile_images/1543145178910818304/AFcbPH6c_400x400.jpg",
    "creatorName": "Ahmed Kazmi",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmfY1k7h5As8htvwV2hSn36nK3S2WQnEeHe7A9uBcPpSMH.png",
    "itemName": "Missing Things I Never Tried | DEMOS",
    "itemRoute": "/profile/ahmedkazmi"
  },
  {
    "creatorAddress": "0xd8f5ba4b9b6f29b9b4aca3cdc3b46bf5bcc9b7ed",
    "creatorImage": "https://static-cdn.jtvnw.net/jtv_user_pictures/efc72373-8f2b-4499-9614-ff66011f7a4f-profile_image-70x70.png",
    "creatorName": "Mike Bass",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmZgm2eRohBfun4vrkc8KdbcyuCKtBbWyokZDfT1f6FLXp.png",
    "itemName": "Live at the402",
    "itemRoute": "/profile/mikebass"
  },
  {
    "creatorAddress": "0x93bb3dc705fb2ad98b696bcc17a0fb7d439d12f4",
    "creatorImage": "https://pbs.twimg.com/profile_images/1480561258759917570/9x2dEZ63_400x400.jpg",
    "creatorName": "Alara",
    "image": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmdisAfqzLJAV5xu95hFLqHcZUQBJ4oMrqf75nTWVsaB75.png",
    "itemName": "Greenpoint",
    "itemRoute": "/profile/alara"
  },
];
